import React, { Component } from 'react';
import Form from './MessageForm';
import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import { withRouter } from 'react-router-dom'
import queryString from 'query-string';
const styles = {
  paper: {
    maxWidth: 1024,
    padding: '10px 20px',
    margin: '20px auto 20px'
  }
}
class AdminMessageForm extends Component {
  constructor(props) {
    super(props);
    this._onClose = this._onClose.bind(this);
  }
  _onClose() {
    const { history } = this.props;
    const search = queryString.parse(window.location.search);
    let url = '/staff/message/list';
    if (search.rt !== undefined && search.rt !== '') url = url+'/'+search.rt;
    else if (search.ru !== undefined && search.ru !== '') url = search.ru;
    history.push(url);

  }
  render() {
    const { id, classes } = this.props;
  return (
    <div>
      <Paper classes={{root: classes.paper}}>
      <Form id={id} onFormComplete={this._onClose} onFormCancel={this._onClose}/>
      </Paper>
    </div>
  );
}
}

export default withRouter(withStyles(styles)(AdminMessageForm));
